export default "__VITE_ASSET__De4rJCe0__"